import React from 'react';
import { NavigationMenuItem } from '../../models/NavigationMenuItem';
import NavigationItem from './navigation-item';

interface NavigationProps {
    menu: NavigationMenuItem;
}

const NavigationList: React.FC<NavigationProps> = (props) => {
    const { menu } = props;

    return (
        <>
            {menu.items?.map?.(
                (item: NavigationMenuItem): React.ReactNode => (
                    <NavigationItem key={item.id} item={item} />
                )
            )}
        </>
    );
};

export default NavigationList;
